import { toErrorObject } from '../mappers';
import { UploadEvent } from '../../constants/upload-event';
import { UploadStatus } from '../../constants/upload-status';
const ONE_HUNDRED_MEGABYTES = 104857600;
export const errorName = {
  WITH_RESPONSE: 'MediaManagerSDKResponseError',
  NETWORK_ERROR: 'MediaManagerSDKNetworkError',
  NO_RESPONSE_ERROR: 'MediaManagerSDKNoResponseError',
  DEFAULT_ERROR: 'MediaManagerSDKNoResponseError'
};
export const tusErrorKeys = {
  FAIL_RESUME: 'files-manager.upload-tab-body-fail-resume',
  GENERAL: 'wmp_error.general',
  CONNECTIVITY: 'files-manager.upload-tab-body-connectivity',
  NO_RESPONSE: 'files-manager.upload-tab-body-no-response-error',
  SERVER: 'files-manager.upload-tab-body-stopped'
};
export const getTusErrorReason = reason => {
  var _reason$data;
  if (reason != null && (_reason$data = reason.data) != null && (_reason$data = _reason$data.error_info) != null && _reason$data.key) {
    switch (reason.data.error_info.key) {
      case tusErrorKeys.FAIL_RESUME:
        return 'resume_error';
      case tusErrorKeys.SERVER:
        return 'technical_issue';
      case tusErrorKeys.CONNECTIVITY:
      case tusErrorKeys.NO_RESPONSE:
        return 'connectivity_issue';
      case tusErrorKeys.GENERAL:
        return 'general_error';
      default:
        return reason.data.error_info.key;
    }
  }
  return '';
};
function getErrorData(errorCode) {
  const shouldRetryCodes = [403, 404, 409, 410];
  const shouldClearCodes = [400, 412, 415];
  const connectivityErrorCodes = [0];
  const errorData = {
    error_code: '',
    error_description: '',
    error_info: {
      key: '',
      message: '',
      args: ['']
    }
  };
  if (shouldRetryCodes.indexOf(errorCode) !== -1) {
    errorData.error_code = 403;
    errorData.error_info.key = tusErrorKeys.FAIL_RESUME;
  } else if (shouldClearCodes.indexOf(errorCode) !== -1) {
    errorData.error_code = 400;
    errorData.error_info.key = tusErrorKeys.GENERAL;
  } else if (connectivityErrorCodes.indexOf(errorCode) !== -1) {
    errorData.error_code = 0;
    errorData.error_info.key = tusErrorKeys.CONNECTIVITY;
  } else {
    errorData.error_code = errorCode;
    errorData.error_info.key = tusErrorKeys.SERVER;
  }
  return errorData;
}
function generateErrorObject(error, data, code, statusText, name) {
  return {
    name,
    status: code,
    statusText,
    message: error.message,
    code,
    config: {},
    stack: error.stack,
    data,
    request: error.originalRequest
  };
}
function isOnline() {
  return navigator.onLine;
}
export function errorInitialParse(error, tusConfig, setIsResumable, setShouldTryToResume) {
  let errorObject;
  setIsResumable(true);
  if (error.originalResponse) {
    const {
      status,
      statusText
    } = error.originalResponse._xhr;
    const data = getErrorData(status);
    errorObject = generateErrorObject(error, data, data.error_code, statusText, errorName.WITH_RESPONSE);
  } else if (isOnline()) {
    const data = getErrorData(0);
    setShouldTryToResume(true);
    errorObject = generateErrorObject(error, data, data.error_code, '', errorName.NO_RESPONSE_ERROR);
  } else {
    const data = getErrorData(0);
    errorObject = generateErrorObject(error, data, data.error_code, 'offline', errorName.NETWORK_ERROR);
  }
  if (errorObject.data.error_code === 500) {
    setShouldTryToResume(true);
  }
  tusConfig.uploadPromiseReject(toErrorObject(errorObject));
}
export const calculateProgress = (cancelAndProgressConfig, bytesUploaded, bytesTotal) => {
  cancelAndProgressConfig.progressEventEmitter.emit(UploadEvent.Upload, {
    status: UploadStatus.Uploading,
    total: bytesTotal,
    loaded: bytesUploaded
  });
};
export const getTusSettings = (url, params, options) => {
  return {
    ...options.headers,
    endpoint: url,
    chunkSize: ONE_HUNDRED_MEGABYTES,
    retryDelays: [0, 1000, 2000, 3000],
    metadata: params
  };
};
export function emitUploadHasBeenStarted(cancelAndProgressConfig) {
  cancelAndProgressConfig.progressEventEmitter.emit(UploadEvent.Upload, {
    status: UploadStatus.Uploading,
    total: 100,
    loaded: 0
  });
}
function getPutUrl(url, upload_token) {
  return `${url}/${upload_token}`;
}
export const finalize = (http, url, upload_token, params) => http.put(getPutUrl(url, upload_token), null, params);
export function getFileToUpload(file) {
  return file.blob ? file.blob : file;
}